<ngx-spinner bdColor="rgba(51,51,51,0.55)" size="medium" color="#fff" type="line-spin-clockwise-fade"
    [fullScreen]="false">
    <p class="loading">{{ 'general.loading' | translate }}...</p>
</ngx-spinner>

<div class="row ml-0">
    <div class="col-12">
        <h2 class="page-title" tabindex="0">
            {{ isEditMode ? ('aggressor.edit_aggressor' | translate) : ('aggressor.add_aggressor' | translate) }}
        </h2>
    </div>
    <!-- Change the title -->

</div>

<div class="col-12 mb-2">
    <xng-breadcrumb separator=" > ">
        <ng-container *xngBreadcrumbItem="let breadcrumb">
            <span *ngIf="breadcrumb">
                {{ 'breadcrumb.' + breadcrumb | translate }}
            </span>
        </ng-container>
    </xng-breadcrumb>
</div>

<hr>

<div class="col-12">
    <form class="w-100" [formGroup]="addAggressorForm" (ngSubmit)="addAggressorSave()" novalidate>

        <!-- Image Preview -->
        <div class="row" *ngIf="picturePreview">
            <div class="col-3">
                <img [src]="picturePreview ? picturePreview : 'assets/images/default-aggressor.png'"
                    alt="{{'aggressor.profile_picture' | translate}}" width="150" height="200" class="img-round" />
            </div>
        </div>

        <!-- Image Upload -->
        <div class="row pb-2">
            <div class="col-3">
                <span>{{'aggressor.profile_picture' | translate}}</span>
                <div class="custom-file">
                    <input type="file" class="custom-file-input" id="customFileLang" [lang]="lang"
                        title="{{'general.select' | translate}}" accept="image/*"
                        (change)="handleProfilePictureUpload($event.target.files)">
                    <div class="custom-file-label custom-label-user" for="customFileLang" id="fileLabel"
                        title="{{'general.select' | translate}}">
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div id="doc-err" class="col-12 error"></div>
        </div>

        <!-- Aggressor Basic Information -->
        <div class="row">
            <!-- Aggressor Name -->
            <div class="col-6 mb-10">
                <label for="aggressorName">{{'aggressor.name' | translate}}<span class="error">*</span></label>
                <input type="text" id="aggressorName" formControlName="aggressorName" class="form-control"
                    [ngClass]="{ 'is-valid': aggressorName.valid && aggressorName.touched, 'is-invalid': aggressorName.invalid && (formSubmitted || aggressorName.touched || aggressorName.dirty) }"
                    maxlength="100">
                <ng-container
                    *ngIf="addAggressorForm.get('aggressorName').invalid && (formSubmitted || addAggressorForm.get('aggressorName').touched || addAggressorForm.get('aggressorName').dirty)">
                    <div *ngIf="aggressorName['errors']&&aggressorName['errors']['required']"
                        class="text-danger align-left">
                        {{'general.required_field' | translate}}
                    </div>
                    <div *ngIf="(aggressorName['invalid']) && !aggressorName['errors']['required']"
                        class="text-danger align-left">
                        {{'error.name' | translate}}
                    </div>
                </ng-container>
            </div>

            <!-- Primary Address -->
            <div class="col-6 mb-10">
                <label for="aggressorPrimaryAddress">{{'aggressor.primary_address' | translate}}<span
                        class="error">*</span></label>
<input type="text" id="aggressorPrimaryAddress" formControlName="aggressorPrimaryAddress"
    class="form-control" 
    [ngClass]="{ 'is-valid': aggressorPrimaryAddress.valid && aggressorPrimaryAddress.touched, 'is-invalid': aggressorPrimaryAddress.invalid && (formSubmitted || aggressorPrimaryAddress.touched || aggressorPrimaryAddress.dirty) }"
    maxlength="200">
                <ng-container
                    *ngIf="addAggressorForm.get('aggressorPrimaryAddress').invalid && (formSubmitted || addAggressorForm.get('aggressorPrimaryAddress').touched || addAggressorForm.get('aggressorPrimaryAddress').dirty)">
                    <div *ngIf="aggressorPrimaryAddress['errors']&&aggressorPrimaryAddress['errors']['required']"
                        class="text-danger align-left">
                        {{'general.required_field' | translate}}
                    </div>
                    <div *ngIf="aggressorPrimaryAddress['invalid'] && !aggressorPrimaryAddress['errors']['required']"
                        class="text-danger align-left">
                        {{'error.address' | translate}}
                    </div>
                </ng-container>
            </div>

        </div>

        <!-- Addresses -->
        <div class="row">


            <!-- Secondary Address -->
            <div class="col-6 mb-10">
                <label for="aggressorSecondaryAddress">{{'aggressor.secondary_address' | translate}}</label>
                <input type="text" id="aggressorSecondaryAddress" formControlName="aggressorSecondaryAddress"
                    class="form-control" maxlength="200">
                <ng-container
                    *ngIf="addAggressorForm.get('aggressorSecondaryAddress').invalid && (formSubmitted || addAggressorForm.get('aggressorSecondaryAddress').touched || addAggressorForm.get('aggressorSecondaryAddress').dirty)">
                    <div *ngIf="aggressorSecondaryAddress['invalid']" class="text-danger align-left">
                        {{'error.address' | translate}}
                    </div>
                </ng-container>
            </div>
        </div>

        <!-- Protection Order Information -->
        <hr class="hr-m">
        <h5 class="dark-gray-text mb-3">{{'aggressor.protection_order_info' | translate}}</h5>

        <div class="row">
            <!-- Protection Order Number -->
            <div class="col-4 mb-10">
                <label for="protectionOrderNumber">{{'aggressor.order_number' | translate}}<span
                        class="error">*</span></label>
<input type="text" id="protectionOrderNumber" formControlName="protectionOrderNumber"
    class="form-control"
    [ngClass]="{ 'is-valid': protectionOrderNumber.valid && protectionOrderNumber.touched, 'is-invalid': protectionOrderNumber.invalid && (formSubmitted || protectionOrderNumber.touched || protectionOrderNumber.dirty) }"
    maxlength="50">
                <ng-container
                    *ngIf="addAggressorForm.get('protectionOrderNumber').invalid && (formSubmitted || addAggressorForm.get('protectionOrderNumber').touched || addAggressorForm.get('protectionOrderNumber').dirty)">
                    <div *ngIf="protectionOrderNumber['errors']&&protectionOrderNumber['errors']['required']"
                        class="text-danger align-left">
                        {{'general.required_field' | translate}}
                    </div>
                </ng-container>
            </div>

<!-- Start Date -->
<div class="col-4 mb-10">
    <label for="protectionOrderStartDate" class="page-title mt-1 mr-1 text-dark mb-0">
        {{'aggressor.start_date' | translate}}<span class="error">*</span>
    </label><br>
    <mat-form-field class="mm-10 w-100">
        <input matInput
               id="protectionOrderStartDate"
               [matDatepicker]="startDatePicker"
               formControlName="protectionOrderStartDate"
               [max]='currentDate'
               readonly> 
        <span matSuffix class="date-suffix">
            <button class="date-clear-btn" type="button"
                    title="{{'aggressor.clear_date' | translate}}" (click)="clearStartDate()">
                <i class="fa fa-times"></i>
            </button>
            <mat-datepicker-toggle [for]="startDatePicker"></mat-datepicker-toggle>
        </span>
        <mat-datepicker #startDatePicker></mat-datepicker>
    </mat-form-field>
    <ng-container *ngIf="addAggressorForm.get('protectionOrderStartDate').invalid && formSubmitted">
        <div *ngIf="protectionOrderStartDate['errors']&&protectionOrderStartDate['errors']['required']"
             class="text-danger align-left">
            {{'general.required_field' | translate}}
        </div>
    </ng-container>
</div>

<!-- End Date -->
<div class="col-4 mb-10">
    <label for="protectionOrderEndDate" class="page-title mt-1 mr-1 text-dark mb-0">
        {{'aggressor.end_date' | translate}}<span class="error">*</span>
    </label><br>
    <mat-form-field class="mm-10 w-100">
        <input matInput
               id="protectionOrderEndDate"
               [matDatepicker]="endDatePicker"
               formControlName="protectionOrderEndDate"
               [min]='protectionOrderStartDate.value'
               readonly>
        <span matSuffix class="date-suffix">
            <button class="date-clear-btn" type="button"
                    title="{{'aggressor.clear_date' | translate}}" (click)="clearEndDate()">
                <i class="fa fa-times"></i>
            </button>
            <mat-datepicker-toggle [for]="endDatePicker"></mat-datepicker-toggle>
        </span>
        <mat-datepicker #endDatePicker></mat-datepicker>
    </mat-form-field>
    <ng-container *ngIf="addAggressorForm.get('protectionOrderEndDate').invalid && formSubmitted">
        <div *ngIf="protectionOrderEndDate['errors']&&protectionOrderEndDate['errors']['required']"
             class="text-danger align-left">
            {{'general.required_field' | translate}}
        </div>
    </ng-container>
</div>
            </div>

            <!-- End Date -->
            <!-- <div class="col-4 mb-10">
                <label for="protectionOrderEndDate" class="page-title mt-1 mr-1 text-dark mb-0">
                    {{'aggressor.end_date' | translate}}<span class="error">*</span>
                </label><br>
                <mat-form-field class="mm-10 w-100">
                    <input matInput id="protectionOrderEndDate" class="w-auto" [matDatepicker]="endDatePicker"
                        formControlName="protectionOrderEndDate" [min]='protectionOrderStartDate.value' readonly
                        [ngClass]="{ 'is-valid': protectionOrderEndDate.valid && protectionOrderEndDate.touched, 'is-invalid': protectionOrderEndDate.invalid && (formSubmitted || protectionOrderEndDate.touched || protectionOrderEndDate.dirty) }">
                    <button class="p-0 ml-1 mr-1 mt-1 small border-0 bg-white" type="button"
                        title="{{'aggressor.clear_date' | translate}}" matSuffix (click)="clearEndDate()">
                        <i class="fa fa-times dark-gray-text"></i>
                    </button>
                    <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #endDatePicker></mat-datepicker>
                </mat-form-field>
                <ng-container *ngIf="addAggressorForm.get('protectionOrderEndDate').invalid && formSubmitted">
                    <div *ngIf="protectionOrderEndDate['errors']&&protectionOrderEndDate['errors']['required']"
                        class="text-danger align-left">
                        {{'general.required_field' | translate}}
                    </div>
                </ng-container>
            </div> -->
        


        <div class="row">
            <!-- Precinct -->
            <div class="col-4 mb-10">
                <label for="precint">{{'aggressor.precinct' | translate}}</label>
                <input type="text" id="precint" formControlName="precint"
                    class="form-control"
                    [ngClass]="{ 'is-valid': precint.valid && precint.touched, 'is-invalid': precint.invalid && (formSubmitted || precint.touched || precint.dirty) }"
                    maxlength="100">
                <ng-container
                    *ngIf="addAggressorForm.get('precint').invalid && (formSubmitted || addAggressorForm.get('precint').touched || addAggressorForm.get('precint').dirty)">
                    <div *ngIf="precint['invalid']" class="text-danger align-left">
                        {{'error.field_too_long' | translate}}
                    </div>
                </ng-container>
            </div>

            <!-- Agent -->
            <div class="col-4 mb-10">
                <label for="agent">{{'aggressor.agent' | translate}}</label>
                <input type="text" id="agent" formControlName="agent"
                    class="form-control"
                    [ngClass]="{ 'is-valid': agent.valid && agent.touched, 'is-invalid': agent.invalid && (formSubmitted || agent.touched || agent.dirty) }"
                    maxlength="100">
                <ng-container
                    *ngIf="addAggressorForm.get('agent').invalid && (formSubmitted || addAggressorForm.get('agent').touched || addAggressorForm.get('agent').dirty)">
                    <div *ngIf="agent['invalid']" class="text-danger align-left">
                        {{'error.field_too_long' | translate}}
                    </div>
                </ng-container>
            </div>

            <!-- Restricted Area -->
            <div class="col-4 mb-10">
                <label for="restrictedArea">{{'aggressor.restricted_area' | translate}}</label>
                <input type="text" id="restrictedArea" formControlName="restrictedArea"
                    class="form-control"
                    [ngClass]="{ 'is-valid': restrictedArea.valid && restrictedArea.touched, 'is-invalid': restrictedArea.invalid && (formSubmitted || restrictedArea.touched || restrictedArea.dirty) }"
                    maxlength="200">
                <ng-container
                    *ngIf="addAggressorForm.get('restrictedArea').invalid && (formSubmitted || addAggressorForm.get('restrictedArea').touched || addAggressorForm.get('restrictedArea').dirty)">
                    <div *ngIf="restrictedArea['invalid']" class="text-danger align-left">
                        {{'error.field_too_long' | translate}}
                    </div>
                </ng-container>
            </div>
        </div>


        <hr class="hr-m">


        <hr class="hr-m">

        <!-- Error Display -->
        <div class="row text-center pt-2">
            <div id="server_error" class="col-12 error"></div>
        </div>

        <!-- Action Buttons -->
        <div class="row">
            <div class="col-12 text-right">
                <button type="button" title="{{'general.cancel' | translate}}" class="btn btn-red btn-h-red mr-2"
                    (click)="onCancel()">
                    {{'general.cancel' | translate}}
                </button>
                <button type="submit"
                    [disabled]="addAggressorForm.invalid"
                    title="{{ isEditMode ? ('general.save' | translate) : ('general.add' | translate) }}"
                    class="btn btn-green btn-h-green">
                    {{ isEditMode ? ('general.save' | translate) : ('general.add' | translate) }}
                </button>
            </div>
        </div>
        <br>
    </form>
</div>